import React from 'react';
import { GrowableContent, Page } from '@lialo/pwa-ui/lib/PageComponents/Page';
import { AppBar } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import { useTranslation } from 'react-i18next';
import DrawerMenu from '../../../../common/Page/AppBarButtons/DrawerMenu';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import routes from '@lialo/core/lib/pages/utils/routes';
import { FileDownloadOutlined } from '@mui/icons-material';
import { PurchaseCouponInfo } from '@lialo/payment/lib/checkout/coupon';
import config from "../../../../config";

interface Props {
  info: PurchaseCouponInfo;
}

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  alignSelf: 'flex-start',
})) as typeof Button;

export const SuccessPage = ({ info }: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Page>
      <AppBar title={t('tour_detail.purchase_voucher.success.title')} leftElement={<DrawerMenu />} />
      <GrowableContent padding>
        <Typography>{t('tour_detail.purchase_voucher.success.thank_you')}</Typography>
        <StyledButton
          startIcon={<FileDownloadOutlined />}
          variant={'contained'}
          color={'secondary'}
          component={'a'}
          rel="nofollow"
          href={routes.generateVoucherLink(
            config.voucherGeneratorUrl!,
            i18n.language,
            info.shortLink,
            info.couponCode,
            info.validUntil
          )}
          target={'_blank'}
          download={`lialo-voucher-${info.shortLink}.pdf`}
        >
          {t('tour_detail.purchase_voucher.success.btn_download')}
        </StyledButton>
        <Typography>{t('tour_detail.purchase_voucher.success.info_email')}</Typography>
      </GrowableContent>
    </Page>
  );
};
